const copy = {
  preChat: {
    headerText: "How can we help you? Ask our AI chat bot!",
  },
};

export default copy;
